import { Button, Card, message, Space, Switch, Table } from 'antd';
import { get, keyBy, merge, values } from 'lodash';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import CountryApi from '../../functions/api/cms/CountryApi';
import TestimonialApi from '../../functions/api/cms/TestimonialApi';
import MyUtil from '../../functions/MyUtil';
import TableUtils from '../../functions/TableUtils';
import { columnTitles, TABLE } from './columns';

class ListTestimonial extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listTestimonial: [],
      currentTotal: 0,
      currentDataSource: [],
      filteredInfo: TableUtils.getFilterFromUrl(),
      countries: [],
    };
  }

  async componentDidMount() {
    const countries = await CountryApi.index();
    await this.loadTestimonial();
    this.setState({ countries });
  }

  loadTestimonial = async () => {
    const listTestimonial = await TestimonialApi.index();

    this.setState({
      listTestimonial,
      currentTotal: listTestimonial.length,
      currentDataSource: listTestimonial,
    });
  };

  handleInsertButtonClick = () => {
    this.props.history.push('/testimonial/add-testimonial');
  };

  updateStatus = async (id, newStatus) => {
    let result;
    let text;
    if (newStatus) {
      result = await TestimonialApi.publish(id);
      text = 'Hiện đánh giá thành công';
    } else {
      result = await TestimonialApi.unPublish(id);
      text = 'Ẩn đánh giá thành công';
    }

    if (null !== result) {
      message.success(text);
      await this.loadTestimonial();
    } else {
      message.error('Có lỗi xảy ra, xin vui lòng thử lại sau!');
    }
  };

  getStatusFilter = (dataIndex) => {
    const filters = [
      {
        text: '(trống)',
        value: null,
      },
      {
        text: 'Bật',
        value: 1,
      },
      {
        text: 'Tắt',
        value: 0,
      },
    ];
    return {
      filters,
      onFilter: (value, record) => get(record, dataIndex) === value,
    };
  };

  getCountryFilter = (dataIndex) => {
    const { countries } = this.state;

    const filters = countries.map((item) => {
      return {
        text: item.short_name,
        value: item.code,
      };
    });

    filters.push({
      text: '(trống)',
      value: null,
    });

    return {
      filters,
      onFilter: (value, record) => get(record, dataIndex) === value,
    };
  };

  renderStatus = (cell, row) => {
    return (
      <Switch
        defaultChecked={!!cell}
        onChange={(status) => this.updateStatus(row.id, status)}
      />
    );
  };

  tableSourceDidChange = (
    pagination,
    filters,
    sorter,
    { currentDataSource }
  ) => {
    TableUtils.pushFilterToUrl(filters);
    this.setState({
      currentTotal: currentDataSource.length,
      currentDataSource: currentDataSource,
      filteredInfo: filters,
    });
  };

  getColumnConfig = (filteredInfo) => {
    const columnConfigs = [
      {
        dataIndex: 'id',
        key: 'id',
        fixed: 'left',
        filteredValue: filteredInfo.id || null,
        ...TableUtils.getColumnSearchProps('id'),
      },
      {
        dataIndex: 'name',
        key: 'name',
        filteredValue: filteredInfo.name || null,
        ...TableUtils.getColumnSearchProps('name'),
      },
      {
        dataIndex: 'age',
        key: 'age',
      },
      {
        dataIndex: 'nationality',
        key: 'nationality',
        filteredValue: filteredInfo.nationality || null,
        ...this.getCountryFilter('nationality'),
      },
      {
        dataIndex: 'comment',
        key: 'comment',
        filteredValue: filteredInfo.comment || null,
        ...TableUtils.getColumnSearchProps('comment'),
      },
      {
        dataIndex: 'status',
        key: 'status',
        filteredValue: filteredInfo.status || null,
        render: this.renderStatus,
        ...this.getStatusFilter('status'),
      },
      {
        title: null,
        key: 'delete',
        fixed: 'right',
        render: (text, record) => {
          return (
            <Space>
              <Button
                size="small"
                onClick={() =>
                  this.props.history.push(
                    `/testimonial/edit-testimonial/${record.id}`
                  )
                }
              >
                <i className="fas fa-edit" />
              </Button>
            </Space>
          );
        },
      },
    ];

    const titles = columnTitles.filter((t) => t.hideOn !== TABLE.BACKEND);

    // merge titles with configs
    const mergeKey = 'dataIndex';
    return values(
      merge(keyBy(titles, mergeKey), keyBy(columnConfigs, mergeKey))
    );
  };

  render() {
    const { listTestimonial, currentTotal, filteredInfo } = this.state;
    const columns = this.getColumnConfig(filteredInfo);

    return (
      <>
        <h1>Đánh giá</h1>
        <Card className="mb-2" size="small">
          <Space>
            {MyUtil.hasPermission('/testimonial', 'add') && (
              <Button onClick={this.handleInsertButtonClick} type="primary">
                Thêm
              </Button>
            )}
          </Space>
        </Card>
        <Table
          rowKey="id"
          size="small"
          columns={columns}
          dataSource={listTestimonial}
          scroll={{ x: 'max-content' }}
          onChange={this.tableSourceDidChange}
          title={() => `Tổng số: ${currentTotal}`}
        />
      </>
    );
  }
}

export default withRouter(ListTestimonial);
